import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancelPage = () => {
  return (
    <div style={{ paddingTop: '80px', minHeight: '100vh' }}>
      <div className="container" style={{ 
        maxWidth: '700px',
        padding: '5rem 1.2rem',
        textAlign: 'center'
      }}>
        <div className="card" style={{ 
          padding: '3rem 2rem',
          background: 'var(--bg-section)'
        }}>
          <XCircle 
            size={80} 
            style={{ 
              color: '#FF6B6B',
              margin: '0 auto 2rem'
            }} 
          />
          
          <h1 className="heading-1" style={{ marginBottom: '1rem' }}>
            Paiement annulé
          </h1>
          
          <p className="body-large" style={{ marginBottom: '2rem' }}>
            Votre paiement a été annulé. Aucun montant n'a été débité de votre compte.
          </p>

          <p className="body-medium" style={{ marginBottom: '2rem' }}>
            Vous pouvez reprendre votre inscription à tout moment. 
            Si vous avez rencontré un problème, n'hésitez pas à nous contacter.
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <Link to="/programs" className="btn-primary" style={{ width: '100%' }}>
              Choisir une formation
            </Link>
            <Link to="/" className="btn-secondary" style={{ width: '100%' }}>
              Retour à l'accueil
            </Link>
          </div>

          <div className="card accent-purple" style={{ 
            marginTop: '2rem',
            padding: '1.5rem',
            textAlign: 'left'
          }}>
            <h3 className="heading-3" style={{ marginBottom: '0.75rem' }}>
              Besoin d'aide ?
            </h3>
            <p className="body-small" style={{ marginBottom: '1rem' }}>
              Notre équipe est à votre disposition pour répondre à toutes vos questions.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <a href="mailto:apdr.vae@gmail.com" className="body-small" style={{ 
                textDecoration: 'none',
                color: 'var(--text-primary)',
                fontWeight: 500
              }}>
                📧 apdr.vae@gmail.com
              </a>
              <a href="tel:+33123456789" className="body-small" style={{ 
                textDecoration: 'none',
                color: 'var(--text-primary)',
                fontWeight: 500
              }}>
                📞 +33 1 23 45 67 89
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
